import { Injectable, computed, Signal, signal } from '@angular/core';

@Injectable()
export class StockValidationSharedLogicService {
  public canStockValidate!: Signal<boolean>;
  public canSave!: Signal<boolean>;

  private isCreationMode!: Signal<boolean>;
  private isValidated!: Signal<boolean>;
  private lineCount!: Signal<number>;
  private isStockValidated!: Signal<boolean>;

  public setup(signals: {
    isCreationMode: Signal<boolean>;
    isValidated: Signal<boolean>;
    lineCount: Signal<number>;
    isStockValidated: Signal<boolean>;
  }): void {
    this.isCreationMode = signals.isCreationMode;
    this.isValidated = signals.isValidated;
    this.lineCount = signals.lineCount;
    this.isStockValidated = signals.isStockValidated;

    this.canStockValidate = computed(() => {
      return (
        !this.isCreationMode() &&
        this.isValidated() &&
        !this.isStockValidated() &&
        this.lineCount() > 0
      );
    });

    this.canSave = signal(true);
  }

  public getCanDeactivateTitle = () => {
    if (this.canStockValidate()) {
      return 'Doc::CustomerQuote:NotValidatedWishToContinue';
    } else {
      return null;
    }
  };
}
